export default {
  timeFmt: [
    {
      text: '1930年08月',
      value: 'Y.m.z',
      example: '1930年08月'
    },
    {
      text: '1930-08',
      value: 'Y.m',
      example: '1930-08'
    },
    {
      text: '1930-08-05',
      value: 'yyyy-MM-dd',
      example: '1930-08-05'
    },
    {
      text: '1930/8/5',
      value: 'yyyy/MM/dd',
      example: '1930/8/5'
    },
    {
      text: '1930年8月5日',
      value: 'yyyy"年"M"月"d"日"',
      example: '1930年8月5日'
    },
    {
      text: '08-05',
      value: 'MM-dd',
      example: '08-05'
    },
    {
      text: '8-5',
      value: 'M-d',
      example: '8-5'
    },
    {
      text: '8月5日',
      value: 'M"月"d"日"',
      example: '8月5日'
    },
    {
      text: '13:30:30',
      value: 'h:mm:ss',
      example: '13:30:30'
    },
    {
      text: '13:30',
      value: 'h:mm',
      example: '13:30'
    },
    {
      text: '下午01:30',
      value: '上午/下午 hh:mm',
      example: '下午01:30'
    },
    {
      text: '下午1:30',
      value: '上午/下午 h:mm',
      example: '下午1:30'
    },
    {
      text: '下午1:30:30',
      value: '上午/下午 h:mm:ss',
      example: '下午1:30:30'
    },
    {
      text: '08-05 下午01:30',
      value: 'MM-dd 上午/下午 hh:mm',
      example: '08-05 下午01:30'
    }
  ],
  numFmt: [
    {
      text: '1235',
      example: '1235',
      value: '0'
    },
    {
      text: '1234.56',
      example: '1234.56',
      value: '0.00'
    },
    {
      text: '1,235',
      example: '1,235',
      value: '#,##0'
    },
    {
      text: '1,234.56',
      example: '1,234.56',
      value: '#,##0.00'
    },
    {
      text: '1,235',
      example: '1,235',
      value: '#,##0_);(#,##0)'
    },
    {
      text: '1,235',
      example: '1,235',
      value: '#,##0_);[Red](#,##0)'
    },
    {
      text: '1,234.56',
      example: '1,234.56',
      value: '#,##0.00_);(#,##0.00)'
    },
    {
      text: '1,234.56',
      example: '1,234.56',
      value: '#,##0.00_);[Red](#,##0.00)'
    },
    {
      text: '$1,235',
      example: '$1,235',
      value: '$#,##0_);($#,##0)'
    },
    {
      text: '$1,235',
      example: '$1,235',
      value: '$#,##0_);[Red]($#,##0)'
    },
    {
      text: '$1,234.56',
      example: '$1,234.56',
      value: '$#,##0.00_);($#,##0.00)'
    },
    {
      text: '$1,234.56',
      example: '$1,234.56',
      value: '$#,##0.00_);[Red]($#,##0.00)'
    },
    {
      text: '1234.56',
      example: '1234.56',
      value: '@'
    },
    {
      text: '123456%',
      example: '123456%',
      value: '0%'
    },
    {
      text: '123456.00%',
      example: '123456.00%',
      value: '0.00%'
    },
    {
      text: '1.23E+03',
      example: '1.23E+03',
      value: '0.00E+00'
    },
    {
      text: '1.2E+3',
      example: '1.2E+3',
      value: '##0.0E+0'
    },
    {
      text: '1234 5/9',
      example: '1234 5/9',
      value: '# ?/?'
    },
    {
      text: '1234 14/25',
      example: '1234 14/25',
      value: '# ??/??'
    },
    {
      text: '$ 1,235',
      example: '$ 1,235',
      value: '_($* #,##0_);_(...($* "-"_);_(@_)'
    },
    {
      text: '1,235',
      example: '1,235',
      value: '_(* #,##0_);_(*..._(* "-"_);_(@_)'
    },
    {
      text: '$ 1,234.56',
      example: '$ 1,234.56',
      value: '_($* #,##0.00_);_(...($* "-"_);_(@_)'
    },
    {
      text: '1,234.56',
      example: '1,234.56',
      value: '_(* #,##0.00_);...* "-"??_);_(@_)'
    }
  ],
  curcencyFmt: [
    {
      text: '人民币',
      example: '人民币',
      value: '¥'
    },
    {
      text: '美元',
      example: '美元',
      value: '$'
    },
    {
      text: '欧元',
      example: '欧元',
      value: '€'
    },
    {
      text: '英镑',
      example: '英镑',
      value: '￡'
    },
    {
      text: '港元',
      example: '港元',
      value: '$'
    },
    {
      text: '日元',
      example: '日元',
      value: '￥'
    },
    {
      text: '阿尔巴尼亚列克',
      example: '阿尔巴尼亚列克',
      value: 'Lek'
    },
    {
      text: '阿尔及利亚第纳尔',
      example: '阿尔及利亚第纳尔',
      value: 'din'
    },
    {
      text: '阿富汗尼',
      example: '阿富汗尼',
      value: 'Af'
    },
    {
      text: '阿根廷比索',
      example: '阿根廷比索',
      value: '$'
    },
    {
      text: '阿拉伯联合酋长国迪拉姆',
      example: '阿拉伯联合酋长国迪拉姆',
      value: 'dh'
    },
    {
      text: '阿鲁巴弗罗林',
      example: '阿鲁巴弗罗林',
      value: 'Afl'
    },
    {
      text: '阿曼里亚尔',
      example: '阿曼里亚尔',
      value: 'Rial'
    },
    {
      text: '阿塞拜疆马纳特',
      example: '阿塞拜疆马纳特',
      value: '?'
    },
    {
      text: '埃及镑',
      example: '埃及镑',
      value: '￡'
    },
    {
      text: '埃塞俄比亚比尔',
      example: '埃塞俄比亚比尔',
      value: 'Birr'
    },
    {
      text: '安哥拉宽扎',
      example: '安哥拉宽扎',
      value: 'Kz'
    },
    {
      text: '澳大利亚元',
      example: '澳大利亚元',
      value: '$'
    },
    {
      text: '澳门元',
      example: '澳门元',
      value: 'MOP'
    },
    {
      text: '巴巴多斯元',
      example: '巴巴多斯元',
      value: '$'
    },
    {
      text: '巴布亚新几内亚基那',
      example: '巴布亚新几内亚基那',
      value: 'PGK'
    },
    {
      text: '巴哈马元',
      example: '巴哈马元',
      value: '$'
    },
    {
      text: '巴基斯坦卢比',
      example: '巴基斯坦卢比',
      value: 'Rs'
    },
    {
      text: '巴拉圭瓜拉尼',
      example: '巴拉圭瓜拉尼',
      value: 'Gs'
    },
    {
      text: '巴林第纳尔',
      example: '巴林第纳尔',
      value: 'din'
    },
    {
      text: '巴拿马巴波亚',
      example: '巴拿马巴波亚',
      value: 'B/'
    },
    {
      text: '巴西里亚伊',
      example: '巴西里亚伊',
      value: 'R$'
    },
    {
      text: '白俄罗斯卢布',
      example: '白俄罗斯卢布',
      value: 'р'
    },
    {
      text: '百慕大元',
      example: '百慕大元',
      value: '$'
    },
    {
      text: '保加利亚列弗',
      example: '保加利亚列弗',
      value: 'lev'
    },
    {
      text: '冰岛克朗',
      example: '冰岛克朗',
      value: 'kr'
    },
    {
      text: '波黑可兑换马克',
      example: '波黑可兑换马克',
      value: 'KM'
    },
    {
      text: '波兰兹罗提',
      example: '波兰兹罗提',
      value: 'z?'
    },
    {
      text: '玻利维亚诺',
      example: '玻利维亚诺',
      value: 'Bs'
    },
    {
      text: '伯利兹元',
      example: '伯利兹元',
      value: '$'
    },
    {
      text: '博茨瓦纳普拉',
      example: '博茨瓦纳普拉',
      value: 'P'
    },
    {
      text: '不丹努扎姆',
      example: '不丹努扎姆',
      value: 'Nu'
    },
    {
      text: '布隆迪法郎',
      example: '布隆迪法郎',
      value: 'FBu'
    },
    {
      text: '朝鲜圆',
      example: '朝鲜圆',
      value: '?KP'
    },
    {
      text: '丹麦克朗',
      example: '丹麦克朗',
      value: 'kr'
    },
    {
      text: '东加勒比元',
      example: '东加勒比元',
      value: '$'
    },
    {
      text: '多米尼加比索',
      example: '多米尼加比索',
      value: 'RD$'
    },
    {
      text: '俄国卢布',
      example: '俄国卢布',
      value: '?'
    },
    {
      text: '厄立特里亚纳克法',
      example: '厄立特里亚纳克法',
      value: 'Nfk'
    },
    {
      text: '非洲金融共同体法郎',
      example: '非洲金融共同体法郎',
      value: 'CFA'
    },
    {
      text: '菲律宾比索',
      example: '菲律宾比索',
      value: '?'
    },
    {
      text: '斐济元',
      example: '斐济元',
      value: '$'
    },
    {
      text: '佛得角埃斯库多',
      example: '佛得角埃斯库多',
      value: 'CVE'
    },
    {
      text: '福克兰群岛镑',
      example: '福克兰群岛镑',
      value: '￡'
    },
    {
      text: '冈比亚达拉西',
      example: '冈比亚达拉西',
      value: 'GMD'
    },
    {
      text: '刚果法郎',
      example: '刚果法郎',
      value: 'FrCD'
    },
    {
      text: '哥伦比亚比索',
      example: '哥伦比亚比索',
      value: '$'
    },
    {
      text: '哥斯达黎加科朗',
      example: '哥斯达黎加科朗',
      value: '?'
    },
    {
      text: '古巴比索',
      example: '古巴比索',
      value: '$'
    },
    {
      text: '古巴可兑换比索',
      example: '古巴可兑换比索',
      value: '$'
    },
    {
      text: '圭亚那元',
      example: '圭亚那元',
      value: '$'
    },
    {
      text: '哈萨克斯坦坚戈',
      example: '哈萨克斯坦坚戈',
      value: '?'
    },
    {
      text: '海地古德',
      example: '海地古德',
      value: 'HTG'
    },
    {
      text: '韩元',
      example: '韩元',
      value: '?'
    },
    {
      text: '荷属安的列斯盾',
      example: '荷属安的列斯盾',
      value: 'NAf.'
    },
    {
      text: '洪都拉斯拉伦皮拉',
      example: '洪都拉斯拉伦皮拉',
      value: 'L'
    },
    {
      text: '吉布提法郎',
      example: '吉布提法郎',
      value: 'Fdj'
    },
    {
      text: '吉尔吉斯斯坦索姆',
      example: '吉尔吉斯斯坦索姆',
      value: 'KGS'
    },
    {
      text: '几内亚法郎',
      example: '几内亚法郎',
      value: 'FG'
    },
    {
      text: '加拿大元',
      example: '加拿大元',
      value: '$'
    },
    {
      text: '加纳塞地',
      example: '加纳塞地',
      value: 'GHS'
    },
    {
      text: '柬埔寨瑞尔',
      example: '柬埔寨瑞尔',
      value: 'Riel'
    },
    {
      text: '捷克克朗',
      example: '捷克克朗',
      value: 'K?'
    },
    {
      text: '津巴布韦元',
      example: '津巴布韦元',
      value: '$'
    },
    {
      text: '卡塔尔里亚尔',
      example: '卡塔尔里亚尔',
      value: 'Rial'
    },
    {
      text: '开曼群岛元',
      example: '开曼群岛元',
      value: '$'
    },
    {
      text: '科摩罗法郎',
      example: '科摩罗法郎',
      value: 'CF'
    },
    {
      text: '科威特第纳尔',
      example: '科威特第纳尔',
      value: 'din'
    },
    {
      text: '克罗地亚库纳',
      example: '克罗地亚库纳',
      value: 'kn'
    },
    {
      text: '肯尼亚先令',
      example: '肯尼亚先令',
      value: 'Ksh'
    },
    {
      text: '莱索托洛蒂',
      example: '莱索托洛蒂',
      value: 'LSL'
    },
    {
      text: '老挝基普',
      example: '老挝基普',
      value: '?'
    },
    {
      text: '黎巴嫩镑',
      example: '黎巴嫩镑',
      value: 'L￡'
    },
    {
      text: '立陶宛立特',
      example: '立陶宛立特',
      value: 'Lt'
    },
    {
      text: '利比亚第纳尔',
      example: '利比亚第纳尔',
      value: 'din'
    },
    {
      text: '利比亚元',
      example: '利比亚元',
      value: '$'
    },
    {
      text: '卢旺达法郎',
      example: '卢旺达法郎',
      value: 'RF'
    },
    {
      text: '罗马尼亚列伊',
      example: '罗马尼亚列伊',
      value: 'RON'
    },
    {
      text: '马达加斯加阿里亚里',
      example: '马达加斯加阿里亚里',
      value: 'Ar'
    },
    {
      text: '马尔代夫拉菲亚',
      example: '马尔代夫拉菲亚',
      value: 'Rf'
    },
    {
      text: '马拉维克瓦查',
      example: '马拉维克瓦查',
      value: 'MWK'
    },
    {
      text: '马来西亚林吉特',
      example: '马来西亚林吉特',
      value: 'RM'
    },
    {
      text: '马其顿戴第纳尔',
      example: '马其顿戴第纳尔',
      value: 'din'
    },
    {
      text: '毛里求斯卢比',
      example: '毛里求斯卢比',
      value: 'MURs'
    },
    {
      text: '毛里塔尼亚乌吉亚',
      example: '毛里塔尼亚乌吉亚',
      value: 'MRO'
    },
    {
      text: '蒙古图格里克',
      example: '蒙古图格里克',
      value: '?'
    },
    {
      text: '孟加拉塔卡',
      example: '孟加拉塔卡',
      value: '?'
    },
    {
      text: '秘鲁新索尔',
      example: '秘鲁新索尔',
      value: 'S/'
    },
    {
      text: '缅甸开亚特',
      example: '缅甸开亚特',
      value: 'K'
    },
    {
      text: '摩尔多瓦列伊',
      example: '摩尔多瓦列伊',
      value: 'MDL'
    },
    {
      text: '摩洛哥迪拉姆',
      example: '摩洛哥迪拉姆',
      value: 'dh'
    },
    {
      text: '莫桑比克梅蒂卡尔',
      example: '莫桑比克梅蒂卡尔',
      value: 'MTn'
    },
    {
      text: '墨西哥比索',
      example: '墨西哥比索',
      value: '$'
    },
    {
      text: '纳米比亚元',
      example: '纳米比亚元',
      value: '$'
    },
    {
      text: '南非兰特',
      example: '南非兰特',
      value: 'R'
    },
    {
      text: '南苏丹镑',
      example: '南苏丹镑',
      value: '￡'
    },
    {
      text: '尼加拉瓜科多巴',
      example: '尼加拉瓜科多巴',
      value: 'C$'
    },
    {
      text: '尼泊尔卢比',
      example: '尼泊尔卢比',
      value: 'Rs'
    },
    {
      text: '尼日利亚奈拉',
      example: '尼日利亚奈拉',
      value: '?'
    },
    {
      text: '挪威克朗',
      example: '挪威克朗',
      value: 'kr'
    },
    {
      text: '乔治亚拉瑞',
      example: '乔治亚拉瑞',
      value: 'GEL'
    },
    {
      value: '￥'
    },
    {
      text: '瑞典克朗',
      example: '瑞典克朗',
      value: 'kr'
    },
    {
      text: '瑞士法郎',
      example: '瑞士法郎',
      value: 'CHF'
    },
    {
      text: '塞尔维亚第纳尔',
      example: '塞尔维亚第纳尔',
      value: 'din'
    },
    {
      text: '塞拉利昂利昂',
      example: '塞拉利昂利昂',
      value: 'SLL'
    },
    {
      text: '塞舌尔卢比',
      example: '塞舌尔卢比',
      value: 'SCR'
    },
    {
      text: '沙特里亚尔',
      example: '沙特里亚尔',
      value: 'Rial'
    },
    {
      text: '圣多美多布拉',
      example: '圣多美多布拉',
      value: 'Db'
    },
    {
      text: '圣赫勒拿群岛磅',
      example: '圣赫勒拿群岛磅',
      value: '￡'
    },
    {
      text: '斯里兰卡卢比',
      example: '斯里兰卡卢比',
      value: 'Rs'
    },
    {
      text: '斯威士兰里兰吉尼',
      example: '斯威士兰里兰吉尼',
      value: 'SZL'
    },
    {
      text: '苏丹镑',
      example: '苏丹镑',
      value: 'SDG'
    },
    {
      text: '苏里南元',
      example: '苏里南元',
      value: '$'
    },
    {
      text: '所罗门群岛元',
      example: '所罗门群岛元',
      value: '$'
    },
    {
      text: '索马里先令',
      example: '索马里先令',
      value: 'SOS'
    },
    {
      text: '塔吉克斯坦索莫尼',
      example: '塔吉克斯坦索莫尼',
      value: 'Som'
    },
    {
      text: '太平洋法郎',
      example: '太平洋法郎',
      value: 'FCFP'
    },
    {
      text: '泰国铢',
      example: '泰国铢',
      value: '?'
    },
    {
      text: '坦桑尼亚先令',
      example: '坦桑尼亚先令',
      value: 'TSh'
    },
    {
      text: '汤加潘加',
      example: '汤加潘加',
      value: 'T$'
    },
    {
      text: '特立尼达和多巴哥元',
      example: '特立尼达和多巴哥元',
      value: '$'
    },
    {
      text: '突尼斯第纳尔',
      example: '突尼斯第纳尔',
      value: 'din'
    },
    {
      text: '土耳其里拉',
      example: '土耳其里拉',
      value: '?'
    },
    {
      text: '瓦努阿图瓦图',
      example: '瓦努阿图瓦图',
      value: 'VUV'
    },
    {
      text: '危地马拉格查尔',
      example: '危地马拉格查尔',
      value: 'Q'
    },
    {
      text: '委内瑞拉博利瓦',
      example: '委内瑞拉博利瓦',
      value: 'Bs'
    },
    {
      text: '文莱元',
      example: '文莱元',
      value: '$'
    },
    {
      text: '乌干达先令',
      example: '乌干达先令',
      value: 'UGX'
    },
    {
      text: '乌克兰格里夫尼亚',
      example: '乌克兰格里夫尼亚',
      value: 'грн.'
    },
    {
      text: '乌拉圭比索',
      example: '乌拉圭比索',
      value: '$'
    },
    {
      text: '乌兹别克斯坦苏姆',
      example: '乌兹别克斯坦苏姆',
      value: 'so?m'
    },
    {
      text: '西萨摩亚塔拉',
      example: '西萨摩亚塔拉',
      value: 'WST'
    },
    {
      text: '新加坡元',
      example: '新加坡元',
      value: '$'
    },
    {
      text: '新台币',
      example: '新台币',
      value: 'NT$'
    },
    {
      text: '新西兰元',
      example: '新西兰元',
      value: '$'
    },
    {
      text: '匈牙利福林',
      example: '匈牙利福林',
      value: 'Ft'
    },
    {
      text: '叙利亚镑',
      example: '叙利亚镑',
      value: '￡'
    },
    {
      text: '牙买加元',
      example: '牙买加元',
      value: '$'
    },
    {
      text: '亚美尼亚德拉姆',
      example: '亚美尼亚德拉姆',
      value: 'Dram'
    },
    {
      text: '也门里亚尔',
      example: '也门里亚尔',
      value: 'Rial'
    },
    {
      text: '伊拉克第纳尔',
      example: '伊拉克第纳尔',
      value: 'din'
    },
    {
      text: '伊朗里亚尔',
      example: '伊朗里亚尔',
      value: 'Rial'
    },
    {
      text: '以色列新谢克尔',
      example: '以色列新谢克尔',
      value: '?'
    },
    {
      text: '印度卢比',
      example: '印度卢比',
      value: '?'
    },
    {
      text: '印度尼西亚卢比',
      example: '印度尼西亚卢比',
      value: 'Rp'
    },
    {
      text: '约旦第纳尔',
      example: '约旦第纳尔',
      value: 'din'
    },
    {
      text: '越南盾',
      example: '越南盾',
      value: '?'
    },
    {
      text: '赞比亚克瓦查',
      example: '赞比亚克瓦查',
      value: 'ZMW'
    },
    {
      text: '直布罗陀镑',
      example: '直布罗陀镑',
      value: '￡'
    },
    {
      text: '智利比索',
      example: '智利比索',
      value: '$'
    },
    {
      text: '中非金融合作法郎',
      example: '中非金融合作法郎',
      value: 'FCFA'
    }
  ]
}
